var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82416 7.85349C5.73821 7.94722 5.62165 7.99988 5.50012 7.99988C5.37858 7.99988 5.26203 7.94722 5.17607 7.85349L2.58328 5.02499C2.53951 4.97887 2.50459 4.92369 2.48057 4.86269C2.45655 4.80169 2.44391 4.73608 2.44338 4.66969C2.44285 4.6033 2.45444 4.53746 2.47749 4.47601C2.50054 4.41456 2.53457 4.35874 2.5776 4.31179C2.62064 4.26484 2.67181 4.22772 2.72814 4.20258C2.78447 4.17744 2.84482 4.16479 2.90568 4.16536C2.96653 4.16594 3.02667 4.17973 3.08259 4.20594C3.13851 4.23214 3.18909 4.27023 3.23137 4.31799L5.50012 6.79299L7.76887 4.31799C7.85531 4.22691 7.97109 4.17651 8.09126 4.17765C8.21143 4.17879 8.32639 4.23137 8.41137 4.32408C8.49635 4.41678 8.54455 4.54219 8.54559 4.67329C8.54664 4.80439 8.50044 4.93069 8.41695 5.02499L5.82416 7.85349Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.6441ee86fa6122b16dacf784c7b60022.svg";
export { ForwardRef as ReactComponent };